import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { BottomSheetHeaderComponent, FooterButtonsComponent } from '@monorepo-channels/components/ui-pm'

@Component({
	standalone: true,
	imports: [CommonModule, BottomSheetHeaderComponent, FooterButtonsComponent, MatButtonModule],
	selector: 'feature-pm-card-failure',
	template: `
		<ui-pm-bottom-sheet-header [title]="data.title"></ui-pm-bottom-sheet-header>

		<p style="padding-left: 20px; padding-right: 20px; color: var(--content-txt-black)">
			{{ data.error }}
		</p>

		<ui-pm-footer-buttons>
			<button mat-raised-button (click)="clickBtn()">{{ data.btnMessage }}</button>
		</ui-pm-footer-buttons>
	`,
})
export class GenericErrorComponent {
	public dialogRef = inject(MatDialogRef<GenericErrorComponent>, { optional: true })
	public bottomSheetRef = inject(MatBottomSheetRef<GenericErrorComponent>, { optional: true })
	public data =
		inject(MAT_DIALOG_DATA, { optional: true }) ?? inject(MAT_BOTTOM_SHEET_DATA, { optional: true })

	public clickBtn = () => {
		if (this.data?.btnClick) {
			this.data.btnClick()
		}
		return this.bottomSheetRef?.dismiss() || this.dialogRef?.close()
	}
}
